/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface LabelArgs {
  color: string;
  classNames?: string;
}

export default class Label extends Component<LabelArgs> {
  get classNames() {
    let classes = [`fly-label--${this.args.color}`];

    if (this.args.classNames != null) {
      classes.push(this.args.classNames);
    }

    return classes.join(' ');
  }
}
